// @flow

import React, { type Node } from 'react';
import { useTranslation } from 'react-i18next';
import { type Country } from '@tectonics/prs/country';
import { Content, Footer, Main, Title, Wrapper } from '../layout';
import { Logo } from '../logo';

type Props = {|
  +country: Country,
|};

export function CanceledPaymentPage({ country }: Props): Node {
  const { t } = useTranslation('canceled-page');

  return (
    <Wrapper>
      <Main>
        <Content centered>
          <Title>
            {t('fallback.canceledPage.title')}
          </Title>
        </Content>
      </Main>
      <Footer>
        {t('fallback.canceledPage.footerText')} <Logo />
      </Footer>
    </Wrapper>
  );
}
